import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootStateInterface } from "reducer";

import { mapToolsList, MapToolsModes } from "constant";
import features from "features";
import { AuthStateInterface } from "scenes/AuthPage/ducks";
import { MapStateInterface } from "scenes/MapPage/ducks";
import usePolygonHandler from "scenes/MapPage/usePolygonHandler";
import { UnitsManagerStateInterface } from "scenes/UnitsManager/interfaces";

import Switcher from "components/Switcher/Switcher";
import MapLayers from "../MapLayers/MapLayers";
import MapRoutes from "../MapRoutes/MapRoutes";

import styles from "./map-tools.module.scss";

const MapTools = ({ layers, aries, setView, unitsCollection }) => {
  const { mapToolsMode } = useSelector<RootStateInterface, MapStateInterface>(
    (state) => state.map
  );
  const { jwtData } = useSelector<RootStateInterface, AuthStateInterface>(
    (state) => state.auth
  );

  const { creationPolygonParameters } = useSelector<
    RootStateInterface,
    UnitsManagerStateInterface
  >((state) => state.unitsManager);

  const {
    activePolygonsListItem,
    setActivePolygonsListItem,
    openPolygonDrawMode
  } = usePolygonHandler(creationPolygonParameters);

  const dispatch = useDispatch();

  const onChangeCurrentMode = useCallback(
    (val) => () => {
      dispatch(features.map.actions.setMapToolsMode(val));
    },
    [dispatch]
  );

  const toolsOptions = useMemo(() => {
    return jwtData?.sub === "share-token" ? [mapToolsList[0]] : mapToolsList;
  }, [jwtData?.sub]);

  return (
    <div className={styles["wrapper"]}>
      <Switcher
        className={styles["map-mode-switcher"]}
        options={toolsOptions}
        currentOption={mapToolsMode}
        onChange={onChangeCurrentMode}
      />
      {mapToolsMode === MapToolsModes.LAYERS && (
        <MapLayers
          layers={layers}
          aries={aries}
          setView={setView}
          unitsCollection={unitsCollection}
          activePolygonsListItem={activePolygonsListItem}
          setActivePolygonsListItem={setActivePolygonsListItem}
          openPolygonDrawMode={openPolygonDrawMode}
        />
      )}
      {mapToolsMode === MapToolsModes.ROUTES && <MapRoutes />}
    </div>
  );
};

export default MapTools;
